var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpowerment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.5,
    height: 53.548,
    viewBox: "0 0 53.5 53.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62780",
    "data-name": "Group 62780",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107815",
    "data-name": "Path 107815",
    d: "M117.311,134.355c6.081-5.65,23.861-21.867,23.861-21.867s4.423,5.316,2.209,9.3-7.3,9.526-7.3,9.526l11.425-.358a6.238,6.238,0,0,1,6.512,6.826l-.024.177a120.318,120.318,0,0,1-3.1,13.486s-3.234,11.382-6.853,11.993c-4.933.829-31.539.5-31.539.5",
    transform: "translate(-102.58 -112.488)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24646",
    "data-name": "Rectangle 24646",
    width: 14.693,
    height: 30.707,
    rx: 0.748,
    transform: "translate(0 20.812)",
    fill: "none",
    stroke: "#00a6ef",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerment);
export default __webpack_public_path__ + "static/media/empowerment.84fac4e2dfbc7ef2c459400ff27540f0.svg";
export { ForwardRef as ReactComponent };